import { AbstractProductDataCommand } from "./abstractProductDataCommand";
import { TabOptions } from "../arguments/tabOptions";

export class ProductCommand extends AbstractProductDataCommand {
  tab?: TabOptions;
  includeNonEffective?: boolean;
}